import { formatIsoToDate } from '../../../utils';

export const getDriverQualificationsCsvData = data => {
  const csvData = [
    [
      'Number',
      'Driver',
      'City',
      'State',
      'Status',
      'File Type',
      'DQF Specialist',
      'Client Approver',
      'Client Name',
      'Created',
      'Updated',
    ],
  ];

  for (let i = 0; i < data.length; i += 1) {
    csvData.push([
      `${data[i]?.id}`,
      `${data[i]?.driverName || ''}, ${data[i]?.driverId || ''}`,
      `${data[i]?.locationCity?.name || (typeof data[i]?.locationCity === 'string' ? data[i]?.locationCity : '') || ''}`,
      `${data[i]?.locationState?.name || (typeof data[i]?.locationState === 'string' ? data[i]?.locationState : '') || ''}`,
      `${data[i]?.status || ''}`,
      `${data[i]?.fileType || ''}`,
      `${data[i]?.dqOwnerFullName || ''}`,
      `${data[i]?.dqClientApproverUserFullName || ''}`,
      `${data[i]?.name || ''}`,
      `${formatIsoToDate(data[i]?.createdAt) || ''}`,
      `${formatIsoToDate(data[i]?.updatedAt) || ''}`,
    ]);
  }

  return csvData;
};
